import { Component, OnInit, ElementRef, Renderer, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { HrefLang, HrefLangDefinition } from '../shared/hreflang.service';
import { AppSettings } from '../settings/app.settings';
import { SEOService } from '../shared/seo-service';



@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ContactComponent implements OnInit{

  public urlFaq:Object;

  constructor(private meta:Meta,private translate:TranslateService, private element:ElementRef, private renderer:Renderer,
    private title:Title, private hlang:HrefLang, private seoService:SEOService){
        this.translate.get("META_TITLE_CONTACT").subscribe(text=>{
            this.title.setTitle(text);
        });
        this.translate.get("META_DESC_CONTACT").subscribe(text=>{
            let tag:MetaDefinition = {
                name:"description",
                content:text
            };
            this.meta.addTags([tag]);
        });
        let langs = [
          {lang:'es',text:'contacto'},
          {lang:'en',text:'contact'}/*,
          {lang:'fr',text:'contacter'},
          {lang:'it',text:'contatti'},
          {lang:'de',text:'kontakt'}*/
        ];
        langs.forEach(lang => {
        let hreflang_:HrefLangDefinition = {
            rel: "alternate",
            href: `${AppSettings.BASE_DOMAIN}/${lang.lang}/${lang.text}`,
            hreflang: `${lang.lang}`
        }
        this.hlang.addTags([hreflang_]);
        });

        this.seoService.createLinkForCanonicalURL('');
  }


  ngOnInit(){
     this.addStructuredData();
     this.transformUrl('FAQ').subscribe(faq => {

         this.transformUrl('FAQ_URL').subscribe(path => {
        this.urlFaq = {value:`<a style="font-weight:bold;" href='/${this.translate.getDefaultLang()}/${path}'>${faq}</a>`};
      });

        });
        
  }
private addStructuredData(){
    let script = this.renderer.createElement(this.element.nativeElement, 'script');
    this.renderer.setElementAttribute(script, 'type', 'application/ld+json');
    this.renderer.createText(script, 
    `{
      "@context": "http://schema.org",
      "@type": "Organization",
      "url": "` + AppSettings.BASE_DOMAIN + `",
      "logo": "` + AppSettings.LOGO + `",
      "description": "` + AppSettings.DESCRIPTION + `",
      "address":"` + AppSettings.HEADQUARTERS + `",
      "foundingDate":"` + AppSettings.FOUNDED + `",
      "founder": { "@type": "Person",
              "name":"` + AppSettings.FOUNDER + `"},
      "contactPoint": [{
        "@type": "ContactPoint",
        "email": "` + AppSettings.CUSTOMER_SERVICE + `",
        "telephone": "` + AppSettings.PHONE + `",
        "contactType": "Customer Support"
      },{
        "@type": "ContactPoint",
        "email": "` + AppSettings.GROUP_BOOKING + `",
        "telephone": "` + AppSettings.PHONE + `",
        "contactType": "Customer Support"
      }],
      "sameAs": [
        "` + AppSettings.SOCIAL_FB + `",
        "` + AppSettings.SOCIAL_INSTAGRAM + `",
        "` + AppSettings.SOCIAL_LINKEDIN + `",
        "` + AppSettings.SOCIAL_GOOGLEPLUS + `",
        "` + AppSettings.SOCIAL_TWITTER + `",
        "` + AppSettings.SOCIAL_WIKIPEDIA + `"
      ]
    }`
    );
}


    transformUrl(urlToTranslate){
   return this.translate.get(urlToTranslate);
  }

}